module.exports = "/_next/static/images/verifying-email-fa90685ff59f6956f70737c1536fad5f.svg";